import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const HomeHotelIcon = _ref => {
  let {
      size = "26",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M24.8166 27.9997H7.18113C6.13773 27.9997 5.28906 26.9915 5.28906 25.752V13.5189L16.0021 4L26.7087 13.5189V25.752C26.7087 26.9915 25.86 27.9997 24.8166 27.9997ZM5.93814 13.9045V25.752C5.93814 26.5655 6.49635 27.2286 7.18113 27.2286H24.8166C25.5014 27.2286 26.0596 26.5655 26.0596 25.752V13.9045L16.0021 4.96384L5.93814 13.9045Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M19.2377 28H12.7598C12.5813 28 12.4353 27.8265 12.4353 27.6145V15.2117C12.4353 14.9997 12.5813 14.8262 12.7598 14.8262H19.2377C19.4162 14.8262 19.5622 14.9997 19.5622 15.2117V27.6145C19.5622 27.8265 19.4162 28 19.2377 28ZM13.0844 27.2289H18.9131V15.5972H13.0844V27.2289Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.832 20.8346C18.1014 20.8346 18.3188 21.0929 18.3188 21.4129C18.3188 21.7329 18.1014 21.9912 17.832 21.9912C17.5627 21.9912 17.3452 21.7329 17.3452 21.4129C17.3452 21.0929 17.5643 20.8346 17.832 20.8346Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }), __jsx("path", {
    d: "M27.3499 15.861C27.2152 15.861 27.0789 15.8109 26.962 15.7068L16.0023 5.9662L5.03773 15.7068C4.75051 15.9613 4.34321 15.8919 4.12901 15.5507C3.91482 15.2095 3.97323 14.7256 4.26045 14.4712L16.0023 4.03851L27.7393 14.4712C28.0265 14.7256 28.0849 15.2095 27.8707 15.5507C27.7425 15.755 27.5462 15.861 27.3499 15.861Z",
    fill: color,
    stroke: color,
    "stroke-width": "0.5"
  }));
};
export default HomeHotelIcon;